import { DispatchObject } from 'shared/utils/dispatch-object';

export enum ElectronicBillingAction {
  ClearState = 'CLEAR_STATE',
  CompanySelected = 'SET_COMPANY_SELECTED',
}

export type ElectronicBillingDispatchObject<T> = DispatchObject<ElectronicBillingAction, T>;
